<template>
    <div>
        <base-single-collapse
            button-text="Instructions"
            :expanded="expanded"
            class="rounded-lg"
        >
            <slot>Default slot here</slot>
        </base-single-collapse>
    </div>
</template>

<script>

export default {
    name: 'InstructionsBox',
    components: {},
    props: {
        expanded: {  // if true, it STARTS expanded
            type: Boolean,
            default: false,
        }
    },
    data: function() {
        return {
            
        }
    },
    computed: {

    },
    methods: {


    }
}
</script>

<style>

</style>